import { useQuery } from '@tanstack/react-query'

import * as progressAPI from '../api/onboardingProgressAPI'

export function useOnboardingProgress(
  token: string | null,
  orgUuid: string | null
) {
  const query = useQuery({
    queryKey: ['onboardingProgress', orgUuid],
    queryFn: () => progressAPI.loadProgress(token!, orgUuid!),
    enabled: !!token && !!orgUuid,
    gcTime: 0, // Purge cache on unmount so SPA re-entry always fetches fresh data
  })

  return {
    progress: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
  }
}
